import { Link, useLocation } from "react-router-dom";
import { buttonClassName, ErrorState, PageHeader } from "@evolua/ui";

export function ForbiddenPage() {
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? "esta área";

  return (
    <>
      <PageHeader
        title="Acesso negado"
        lead={`Seu perfil não tem permissão para ${from}. O menu esconde atalhos por conveniência — o bloqueio real é sempre validado no servidor.`}
      />
      <ErrorState
        title="Sem permissão"
        description="Se precisar deste acesso, fale com o RH ou o admin do tenant."
        action={
          <Link to="/" className={buttonClassName({ variant: "primary" })}>
            Voltar ao início
          </Link>
        }
      />
    </>
  );
}
